export const FETCH_DOCTORS_PACKAGES_REQUEST = "FETCH_DOCTORS_PACKAGES_REQUEST";
